<template>
  <div class="page-1-container">
    <div class="header-wrapper">
      <img :src="require(`@/assets/images/message/notification-wa.svg`)" width="233px" />
    </div>
    <FormulateForm ref="formRef" :errors="formErrors" class="my-4">
      <div class="title">Dapatkan Notifikasi Ketika Kendaraan Sudah Dekat</div>
      <div class="subtitle">Info pelacakan akan dikirimkan via Whatsapp</div>
      <FormulateInput
        key="phone_number"
        ref="phone-number-ref"
        v-model="formValues.phone_number"
        name="phone_number"
        placeholder="8xxxxxxxx"
        class="my-2 mt-3"
        type="text"
        validation-name="No. Whatsapp"
        :validation="[['bail'], ['required'], ['max:100'], ['number']]"
        :validation-messages="{
          required: ({ name }) => `${name} ${$t('global.validation.required')}`,
        }"
        error-behavior="value"
        @input="onChange"
      >
        <template #prefix>
          <span class="formulate-input-prefix">+62</span>
        </template>
      </FormulateInput>
      <div class="d-flex my-2 gap-2 align-items-center">
        <FormulateInput
          v-model="addressFullName"
          name="address"
          class="location-input"
          placeholder="Tentukan lokasi"
          validation-name="Lokasi"
          validation="required"
          :validation-messages="{
            required: ({ name }) => `${name} ${$t('global.validation.required')}`
          }"
          readonly
          @click.native="$emit('change-page', 2)"
        >
          <template #suffix>
            <i class="mc-icon icon-fill_chevron-right" />
          </template>
        </FormulateInput>
        <!-- TODO: next development add our current gps -->
        <!-- <McButton variant="secondary" text="" icon="icon-fill_target" /> -->
      </div>
    </FormulateForm>
    <div class="d-flex flex-column gap-2">
      <McButton variant="secondary" text="Kirim" block @click="handleSubmit" />
      <McButton variant="minimal" text="Lain kali" block @click="handleSubmitLater" />
    </div>
  </div>
</template>

<script>
import { MixPanel } from '@/mixin/mixpanel'

import McButton from '@/components/McButton'

import { mapState } from 'vuex'
import { EventBus } from '../../../lib/event-bus'

export default {
  components: {
    McButton,
  },
  mixins: [MixPanel],
  emits: ['change-page'],
  computed: {
    ...mapState('trackingTemp', ['formValues', "formErrors"]),
    addressFullName: {
      get() {
        return this.formValues.address?.fullName || ''
      },
      set() {}
    }
  },
  methods: {
    ValidateForm() {
      this.$refs.formRef.showErrors()
      return this.$refs.formRef.hasErrors
    },
    handleSubmit() {
      EventBus.$emit('handle-submit-notif-wa')
    },
    handleSubmitLater() {
      this.track('Pelacakan Sementara Remind Later Clicked')
      
      this.$store.dispatch('trackingTemp/resetAllState')
      this.$bvModal.hide('notification-wa-modal')
    },
    onChange() {
      this.$store.dispatch('trackingTemp/resetFormErrors')
    }
  }
}
</script>
